import React from "react";
const Quote: React.FC = () => (
  <svg fill="none" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
    <circle cx="29.903" cy="29.903" r="29.903" fill="url(#a)" />
    <path
      d="m37.113 38.398c-1.8695 0-3.3674-0.5857-4.4937-1.757-1.1262-1.1938-1.6893-2.8155-1.6893-4.8653 0-2.4777 0.8109-5.0793 2.4326-7.8047 1.6443-2.748 3.8855-5.2933 6.7236-7.6359l2.6354 2.23c-0.5406 0.4955-1.1037 1.2163-1.6893 2.1623-0.5631 0.9235-1.07 1.9146-1.5204 2.9733-0.428 1.0361-0.7096 2.0047-0.8447 2.9056 1.4416 0.3379 2.5791 1.0249 3.4125 2.061 0.8334 1.0362 1.2501 2.275 1.2501 3.7166 0 1.7569-0.5744 3.1985-1.7232 4.3247-1.1487 1.1262-2.6466 1.6894-4.4936 1.6894zm-15.238 0c-1.8695 0-3.3674-0.5857-4.4936-1.757-1.1037-1.1938-1.6556-2.8155-1.6556-4.8653 0-2.4777 0.8109-5.0793 2.4327-7.8047 1.6217-2.748 3.8517-5.2933 6.6898-7.6359l2.6691 2.23c-0.5406 0.4955-1.1037 1.2163-1.6893 2.1623-0.5631 0.9235-1.0699 1.9146-1.5204 2.9733-0.428 1.0361-0.7096 2.0047-0.8447 2.9056 1.4416 0.3379 2.5791 1.0249 3.4125 2.061 0.8334 1.0362 1.2501 2.275 1.2501 3.7166 0 1.7569-0.5857 3.1985-1.7569 4.3247-1.1488 1.1262-2.6467 1.6894-4.4937 1.6894z"
      fill="#fff"
    />
    <defs>
      <linearGradient
        id="a"
        x1="29.903"
        x2="29.903"
        y2="59.807"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#419FFB" offset="0" />
        <stop stopColor="#1B66F9" offset="1" />
      </linearGradient>
    </defs>
  </svg>
);

export default Quote;
